import { render, staticRenderFns } from "./academic.vue?vue&type=template&id=6d0a022a&scoped=true&lang=pug"
import script from "./academic.vue?vue&type=script&lang=ts"
export * from "./academic.vue?vue&type=script&lang=ts"
import style0 from "./academic.vue?vue&type=style&index=0&id=6d0a022a&prod&lang=stylus&scoped=true"
import style1 from "./academic.vue?vue&type=style&index=1&id=6d0a022a&prod&lang=stylus&scoped=true"
import style2 from "./academic.vue?vue&type=style&index=2&id=6d0a022a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0a022a",
  null
  
)

export default component.exports